import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import { PERMISSION_TACHO_CORRECTION } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Corrections from '../../components/Corrections';

export const Route = createFileRoute('/_authenticated/corrections')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_TACHO_CORRECTION, ['read'], '/unauthorized', context);

    return {
      ...context,
      isNavigatorEnabled: false,
      documentTitle: {
        main: 'menu.corrections',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CorrectionsRoute,
});

function CorrectionsRoute() {
  const vehicleRouteParams = useMatchRoute()({ to: '/corrections/$vehicleId' });
  const routeVehicleId =
    vehicleRouteParams && /^\d+$/.test(vehicleRouteParams.vehicleId)
      ? Number(vehicleRouteParams.vehicleId)
      : null;

  return (
    <>
      <Corrections routeVehicleId={routeVehicleId} />
      {/* Outlet will render child routes (detail modal, etc.) on top */}
      <Outlet />
    </>
  );
}
